export enum CampaignType {
    DMA_LOB = "DMA_LINE_OF_BUSINESS",
}

export interface CampaignSaveFacadeInput {
    appName?: string;
    reviewId?: string;
    type: string;
}
